@if (isNavigating || isLoading) {
    <div class="tw-fixed tw-inset-0 tw-z-[9999] tw-cursor-wait tw-bg-transparent"></div>
}

<div class="tw-h-full"
    [class.tw-pointer-events-none]="isNavigating || isLoading">
    @if(modulePath){
        @if(activeTabsCount > 1) {
            <app-history-module-tabs 
                [showSales]="permissions.sales"
                [showEInvoices]="permissions.e_invoices"
                [showSalesDataSent]="permissions.sales_data_sent"
                [getTabChange]="tabChange"
                (tabPanelChange)="changeTab($event)"
            >
                <ng-container Sales [ngTemplateOutlet]="sales" ></ng-container>
                <ng-container eInvoices [ngTemplateOutlet]="e_invoices" ></ng-container>
                <ng-container SalesDataSent [ngTemplateOutlet]="sales_data_sent"></ng-container>
            </app-history-module-tabs>
        } 
        
        @else if(activeTabsCount === 1) {
            <div class="tw-h-full">
                @switch (singleTabType) {
                    @case ('sales') { <ng-container [ngTemplateOutlet]="sales" /> }
                    @case ('e_invoices') { <ng-container [ngTemplateOutlet]="e_invoices" /> }
                    @case ('sales_data_sent') { <ng-container [ngTemplateOutlet]="sales_data_sent" /> }
                }
            </div>
        }
    }
    @else {
        <div appUpgradeUiView></div>
    }
</div>


<ng-template #sales>
    @if (tabActive === 'sales') {
        <app-history-sales />
    }
</ng-template>

<ng-template #e_invoices>
    @if (tabActive === 'e_invoices') {
        <app-history-e-invoices-showcase />
    }
</ng-template>

<ng-template #sales_data_sent>
    @if (tabActive === 'sales_data_sent') {
        <app-history-sales-data-sent-showcase />
    }
</ng-template>